import { render } from "./Cancelled.vue?vue&type=template&id=6dc0484e&scoped=true"
import script from "./Cancelled.vue?vue&type=script&lang=js"
export * from "./Cancelled.vue?vue&type=script&lang=js"

import "./Cancelled.vue?vue&type=style&index=0&id=6dc0484e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc0484e"]])

export default __exports__